import { Components, Theme } from "@mui/material"

export const MuiToggleButton: Required<Components<Theme>>["MuiToggleButton"] = {
  styleOverrides: {
    root: ({ theme: { palette, shadows, uisk, typography } }) => ({
      ...typography["Text md/Medium"],
      textTransform: "none",
      border: "none",
      color: palette["text-tertiary"],
      padding: `${uisk.spacing.none} ${uisk.spacing.md}`,
      "&.MuiToggleButtonGroup-firstButton, &.MuiToggleButtonGroup-middleButton, &.MuiToggleButtonGroup-lastButton":
        {
          borderRadius: uisk.radius.full,
        },
      "&.Mui-selected, &.Mui-selected:hover": {
        color: palette["text-brand-primary"],
        backgroundColor: palette["bg-tertiary"],
        boxShadow: shadows[1],
      },
    }),
  },
}
